import { render, staticRenderFns } from "./MessageThread.vue?vue&type=template&id=5d8ba710&scoped=true"
import script from "./MessageThread.vue?vue&type=script&lang=js"
export * from "./MessageThread.vue?vue&type=script&lang=js"
import style0 from "./MessageThread.vue?vue&type=style&index=0&id=5d8ba710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8ba710",
  null
  
)

export default component.exports